import { GuestBot } from "../../interfaces"

interface InlineButton {
  text: string
  url: string
}
export interface InlineKeyboard {
  inline_keyboard: InlineButton[][]
}

export const buttonsToInlineKeyboard = (
  buttons?: GuestBot.Button[][],
): InlineKeyboard | undefined => {
  if (!buttons?.length) return undefined
  const rows = buttons
    .map((row) =>
      row
        .filter((b): b is GuestBot.Button & { url: string } => !!b.url)
        .map((b) => ({ text: b.text, url: b.url })),
    )
    .filter((row) => row.length > 0)
  return rows.length ? { inline_keyboard: rows } : undefined
}

export const inlineKeyboardToButtons = (
  kb?: InlineKeyboard | null,
): GuestBot.Button[][] | undefined => {
  if (!kb?.inline_keyboard?.length) return undefined
  const rows = kb.inline_keyboard
    .map((row) => row.map((b) => ({ text: b.text, url: b.url })))
    .filter((row) => row.length > 0)
  return rows.length ? rows : undefined
}
